export enum DistributionLaneApiUrls {
    GetDistributionLanes='/api/DistributionLane/GetDistributionLanes',
  }
